
import React, { useEffect, useState } from 'react'

import { Button, Modal, Card } from "antd";
import { useStoreUpdaterWithAPI } from '../../../../../../../Hooks/UseStoreUpdaterWithApi';
import { APIConstants } from '../../../../../../../Common/APIConstants';
import { calculateDateRangeFromDate } from '../../../../../../../Utils/DateConverstion';
import { useNavigate } from 'react-router-dom';
import { TEMPERATURE_DASHBOARD } from '../../../../../../../Common/Constants';
import { useSelector } from 'react-redux';

const TempMeters = ({item}) => {
  const navigate = useNavigate() 
    const { makeRequest } = useStoreUpdaterWithAPI();
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [selectedMeters, setSelectedMeters] = useState([])
    const [input, setInput] = useState([])
    const [chartSkip, setChartSkip] = useState(true)
    const [steamMeterData, setSteamMeterData] = useState([]);
    
    const showModal= () =>{
      console.log(steamMeterData)
    // setInputData();
    // setSelectedMeters(steamMeterData)
    // setIsModalVisible(true)
    // navigate(`${TEMPERATURE_DASHBOARD}/temperature-convertor-status/temperature-convertor-status-popup`);
    }
    
    const handleCancel = () => {
        setIsModalVisible(false);
        navigate(`${TEMPERATURE_DASHBOARD}/temperature-convertor-status`);
      };
    
      console.log(input)


      
// const fetchSteamMeterLive = () => {
//     const url = `${APIConstants.GET_STEAM_METER_STATUS_DETAILS}?SectionID=${input.SectionID}&ConverterorGroupID=${input.ConverterorGroupID}&MeterIds=${input.MeterIds}&FromDate=${input.FromDate}&Todate=${input.ToDate}}`;
//     // console.log(url);

//     makeRequest({
//       type: APIConstants.GET,
//       url: url,
//     }).then((res) => {
//       setSteamMeterData(res); //we get modal data here after click
//       console.log(res);
//     });
//   };

  // useEffect(() => {       
  //   if (input) {
  //     fetchSteamMeterLive();
  //   }
  // }, [input]);
 
  // useEffect(()=>{
  //   setSelectedMeters(steamMeterData ? steamMeterData : []);
  // },[steamMeterData])

  const setInputData = (id) => {
    console.log(item);
    // console.log('first');
    const ids = item.temperature;
    const currentDate = new Date();
    const { from, to } = calculateDateRangeFromDate(currentDate, 5, 1);
    console.log(ids);
    console.log(from,to);
  
    const inputData = {
      SectionID:1,
      // ConverterorGroupID: id,
       ConverterorGroupID: Number(ids),
      MeterIds: 0,
      FromDate: from,
      ToDate:  to,
      // FromDate:  "2023-11-25T06:00:00.000Z",
      // ToDate:  "2023-11-25T10:00:00.000Z",
    };
  console.log(inputData) 
    // const queryString = inputData;
    // setInput(queryString);
  
    // http://20.244.40.160:81/TVSDashBoard/GetsteamMeterStatusDetails?SectionID=1&ConverterorGroupID=22&MeterIds=0&FromDate=2024-7-18T13:55:02.000Z&Todate=2024-7-18T14:01:02.000Z}
    // "http://20.244.40.160:81/TVSDashBoard/GetsteamMeterStatusDetails?SectionID=1&ConverterorGroupID=22&MeterIds=0&FromDate=2023-11-25T06%3A00%3A00.000Z&Todate=2023-11-25T10%3A00%3A00.000Z"
  
    const url = `${APIConstants.GET_METER_STATUS_TEMPERATURE}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&FromDate=${inputData.FromDate}&Todate=${inputData.ToDate}`;
      // console.log(url);
  
      makeRequest({
        type: APIConstants.GET,
        url: url,
      }).then((res) => {
  
        console.log(res);
        if (res.length>0 ) {
          setSteamMeterData(res); //we get modal data here after click
        }
      });
  };  

  
const mode = useSelector((state) => state.darkMode);

const { isdarkMode } = mode;


  return (
    <div className={`flex px-2 py-2 flex-wrap rounded-md`}>
    <Card
      onClick={() => showModal()}
      className={`w-52 my-1 mx-1 rounded-md border-2 text-center ${isdarkMode ? 'ant-card-background ' : 'whitemode'}`}
      style={{
        // borderColor: "green",
        cursor: "pointer",
      }}
      headStyle={{
        backgroundColor: `${item.meterStatus === "OFF" ? "#f44336" : item.meterStatus === "NO" ? "green" : " #FFFF00"}`,
        color: 'black',
      }}
      title={
        <p
          className="py-2 h-auto font-bold"
          style={{
            margin: 0,
            padding: '5px 0'
          }}
        >  
          {item.sitename}
        </p>
      }
    >
        <div className={`space-y-3 h-auto font-bold text-black ${isdarkMode ? 'ant-card-body-padding ' : 'whitemode'}`}>
  
        <p
          className="border-b-2 my-3 h-auto pb-2 w-full"
          style={{
            borderBottomWidth: '2px',
            borderBottom: `2px solid ${item.meterStatus === "OFF" ? "#f44336" : item.meterStatus === "NO" ? "green" : " #FFFF00"}`
          }}
        >
          Total meters: {item.totalMeters}
        </p>
        <p
          className="border-b-2 my-3 h-auto pb-2 w-full"
          style={{
            borderBottomWidth: '2px',
            borderBottom: `2px solid ${item.meterStatus === "OFF" ? "#f44336" : item.meterStatus === "NO" ? "green" : " #FFFF00"}`
          }}
        >
          Active meters: {item.noMeterCount}
        </p>
        <p className="h-auto pb-4">
          Inactive meters: {item.offMeterCount}
        </p>
      </div>
    </Card>
    <ModalFunction steamMeterData={steamMeterData} isModalVisible={isModalVisible} handleCancel={handleCancel} />
  </div>
  )
}


const ModalFunction = ({steamMeterData,isModalVisible, handleCancel}) => {
    console.log(steamMeterData)
    const mode = useSelector((state) => state.darkMode);

    const { isdarkMode } = mode;   
    return (
      
      <Modal
        open={isModalVisible}
        onCancel={handleCancel}
        closable={false}
        className={`custom-modal ${isdarkMode ? "custom-modal-dark custom-modal-header" : "whitemode"} `}
        width={1000}
        footer={null}
        // footer={[
        //   <Button
        //     className="mr-5 mb-5  bg-green-400"
        //     key="back"
        //     onClick={handleCancel}
        //   >
        //     Cancel
        //   </Button>,
        // ]}
        style={{ padding: 0 }}
        title={
          <div  className='text-red-500 text-xl rounded-xl text-center '
          style={{
            color: steamMeterData[0]?.meterStatus === 'OFF' ? 'custom-modal-header' : 'whitemode', 
            padding: 5,
            borderRadius: "8px 8px 8px 8px "
          }}
          >
            Meters status
          </div> 
        }
      >
        {
          steamMeterData.length > 0 ? 
        <div className="flex flex-wrap justify-start  gap-4 py-3">
          {
            steamMeterData.map((item,index)=>(
          <div key={item} className = {`w-52 h-50 my-1 mx-1 rounded-md ant-modal-card border-2 text-center  ${item.meterStatus === "OFF" ? "border-red-500" : item.meterStatus === "NO" ? "border-green-600" : "border-[ #FFFF00]"}`}>
            <p className={`py-2 h-auto font-bold text-black  ${item.meterStatus === "OFF" ? "bg-red-500" : item.meterStatus === "NO" ? "bg-green-600" : "bg-[#FFFF00]"}`}>
              {item.metername}
            </p>
            <div className={`space-y-0 h-auto font-bold text-black ${isdarkMode ? "text-white" : "whitemode"} `}>
              <p className={`border-b-2 my-3 h-auto  pb-2 ${item.meterStatus === "OFF" ? "border-red-500" : item.meterStatus === "NO" ? "border-green-600" : "border-[ #FFFF00]"}`}>
                RH: {item.rh}
              </p>
              <p className="h-auto pb-4  border-green-600">Temperature : {item.temperature}</p>
            </div>
          </div>
            ))
          }
  
        </div>
        :
        <div className={`${isdarkMode ? 'text-white': 'text-black'}`}>
          No Meter Available.
        </div>
        }

          <div className="flex w-full justify-end ">
          <button
            className="mr-5 mb-5 font-semibold  bg-green-400 hover:text-green-500 hover:border-green-500 hover:bg-white"
            key="back"
            onClick={handleCancel} 
          >
            Cancel
          </button>,
          </div>
      </Modal>
    );
  };

export default TempMeters
